export interface PlatformNewsItem {
  id: string;
  createdAt: string;
  location: string;
  author: string;
  teaserImageUrl: string;
  externalLink?: string;
  translatedEntities: {
    language: string;
    translatedMessage: {
      categories: Array<string>;
      subject: string; //News item title
      summary: string; //Short description
      message: string;
    };
  };
  recipients: [
    {
      user: string;
      read: boolean;
    },
  ];
  relevantToAllUsers: boolean;
}

export const newsDefaultPeriodFromDate = '2020-01-01T00:00:00Z';
export const newsDefaultPeriodToDate = '9999-12-31T23:59:59.000Z';
